module.exports = __webpack_public_path__ + "img/i-usa.1796066b.svg";